import { useQuery } from '@tanstack/react-query'
import { usePurchasedProductIdsQuery } from '@/generated/graphql'

/** Fetches purchased product IDs for Discoverie “my purchases only” (Typesense filter). */
export function usePurchasedProductIdsForDiscoverie(
  enabled: boolean,
  customerId: number | undefined
) {
  return useQuery({
    queryKey: ['discoveriePurchasedProductIds', customerId],
    queryFn: async () => {
      const data = await usePurchasedProductIdsQuery.fetcher()()
      return data.purchasedProductIds ?? []
    },
    enabled: enabled && !!customerId && customerId > 0,
    staleTime: 5 * 60 * 1000,
  })
}
